import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RadioComponent } from './radio.component';
import { IconModule } from '../icon/icon.module';

@NgModule({
  declarations: [RadioComponent],
  imports: [CommonModule, IconModule],
  exports: [RadioComponent],
})
export class radioModule {}
